import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpresaDiastoleranciaComponent {
  agregando = false
  idProyecto

  constructor (ViaticosProyectosProyectoDiastolerancia) {
    this.ViaticosProyectosProyectoDiastolerancia = ViaticosProyectosProyectoDiastolerancia
  }

  $onChanges (changes) {
    if (changes.idProyecto) {
      this.idProyecto = changes.idProyecto.currentValue
      this.agregando = false
      this.promise = this.ViaticosProyectosProyectoDiastolerancia.get(this.idProyecto)
        .then(({data}) => {
          this.data = data
        })
    }
  }

  guardar () {
    return this.ViaticosProyectosProyectoDiastolerancia.post(this.idProyecto, this.data)
      .then((resolve) => {
        // this.data = resolve.data;
      })
  }
}

module.component('viaticosConfiguracionEmpresaDiastolerancia', {
  controller: ViaticosConfiguracionEmpresaDiastoleranciaComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empresa/diastolerancia/component.js